import apiClient from '@/services/axios'

export const getDashboard = ({ type, params }) => {
  return apiClient({
    method: 'get',
    url: `bi/dashboard/dash/chart/${type}`,
    params,
  })
}

export const getDashboardChannels = (params) => {
  return apiClient({
    method: 'get',
    url: 'bi/dashboard2/dash/channels',
    params,
  })
}

export const getDashboardData = ({ url, params }) => {
  return apiClient({
    method: 'get',
    url: `bi/dashboard2/dash_ord_date/chart/${url}`,
    params,
  })
}

export const countSales = (params) => {
  return apiClient({
    method: 'get',
    url: 'bi/dashboard2/dash/sales-count',
    params,
  })
}

export const downloadSales = (params) => {
  return apiClient({
    method: 'get',
    url: 'bi/dashboard2/dash/sales-excel',
    params,
  })
}

export const checkRequestExportSales = ({ request_id, params }) => {
  return apiClient({
    method: 'get',
    url: `bi/dashboard2/dash/request-status/${request_id}`,
    params,
  })
}

export const getShippingOrderFromDashboard = ({ signal, order_id }) => {
  return apiClient({
    signal,
    method: 'get',
    url: `bi/dashboard2/internal/order/detail/${order_id}`,
  })
}

export const downloadSalestoExportHistory = (params) => {
  return apiClient({
    method: 'post',
    url: 'bi/dashboard2/export-history/sales-excel',
    params,
  })
}

export const getListExportHistory = ({ workspace_id, params }) => {
  return apiClient({
    method: 'get',
    url: `bi/dashboard2/export-history/list`,
    params,
  })
}

export const getDashboardSalesChannels = (params) => {
  return apiClient({
    method: 'get',
    url: 'bi/dashboard2/dash_ord_date/sales_channels',
    params,
  })
}